// Taşeron portalı — Personeli (panel yetkisi YOK) tam-ekran indirme görünümü (plan D3;
// api-contract §26). Giriş/aktivasyon sonrası panel-erişim probu `forbidden` dönerse
// (`useSupplierContractorAccess`) TÜM kabuk yerine YALNIZ bu ekran gösterilir: iOS/Android
// indirme butonları (`GET /app-settings`) + çıkış. Menü/nav/başka içerik YOKTUR — sahip kararı
// ("başka bişey görünmesin"). Bu, Personeli'nin bugünkü sınırlı web görünümünü (Belgelerim)
// bilinçli olarak kaldırır (mobile'a taşınır).
//
// Ekran auth'ludur ama panel-gate DIŞIdır (Personeli erişebilmeli). Link boşsa "yakında".

import { Logo, Spinner, useAuthStore } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { AppDownloadLinks } from '../components/AppDownloadLinks';
import { UserMenu } from '../components/UserMenu';
import { useAppSettings } from '../lib/useAppSettings';
import { useSupplierMe } from '../lib/useSupplierMe';

export function AppDownloadOnly() {
  const { t } = useTranslation();
  const principal = useAuthStore((s) => s.principal);
  const { me } = useSupplierMe();
  const { iosAppUrl, androidAppUrl, isLoading } = useAppSettings();

  // Görünen kimlik: ad-soyad (self-profil) — yoksa e-posta/telefon (token).
  const fullName = me ? `${me.firstName} ${me.lastName}`.trim() : '';
  const displayName = fullName || principal?.email || '';

  return (
    <div className="flex min-h-screen flex-col bg-bg">
      {/* S37 (S9): 48px koyu şerit — marka + kabuk hesap menüsü (dil radyo grubu + çıkış). */}
      <header className="flex h-12 items-stretch justify-between border-b border-shell-border bg-shell text-shell-fg">
        <div className="flex min-w-0 items-center gap-2.5 px-3">
          <Logo className="h-9 shrink-0 text-shell-fg" title={t('app.name')} />
        </div>
        <UserMenu showProfile={false} />
      </header>

      <main className="flex flex-1 items-center justify-center p-4 sm:p-6">
        <div className="flex w-full max-w-md flex-col items-center gap-6 text-center">
          <div className="flex flex-col gap-2">
            <h1 className="text-2xl font-semibold text-fg">{t('appDownload.title')}</h1>
            <p className="text-sm text-muted">{t('appDownload.personnelBody')}</p>
            {displayName ? (
              <p className="text-xs text-muted">
                {t('appDownload.signedInAs', { name: displayName })}
              </p>
            ) : null}
          </div>

          <div className="w-full">
            {isLoading ? (
              <div className="flex min-h-[6rem] items-center justify-center">
                <Spinner label={t('appDownload.loading')} />
              </div>
            ) : (
              <AppDownloadLinks iosAppUrl={iosAppUrl} androidAppUrl={androidAppUrl} size="lg" />
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
